import { FormSection } from "components/MainSectionTemplate/types";
import { YesNoRadioGroupForInPageEditing, YesNoText } from "components/ValidatedFields/YesNoRadioGroup";
import React from "react";

interface Props {
  instruction: server.dto.UpdateClientConfigurationInstruction
}

export const ShowSection = (props: Props): FormSection => {
  return {
    key: "showSettings",
    type: "regular",
    title: site.currentEnvironment.show.singular,
    fields: [{
      key: "show_costs",
      label: RESX.Financial.Costs,
      render: () => <YesNoText value={props.instruction.showDisplayCosts} />,
      inPageEdit: {
        render: ({ onChange }) => <YesNoRadioGroupForInPageEditing
          value={props.instruction.showDisplayCosts}
          onChange={(v) => onChange(v, true)}
        />,
        type: "custom",
        initialValue: props.instruction.showDisplayCosts,
        submitChange: (value: boolean) => {
          return window.CoreApi.ClientConfiguration.Update({ ...props.instruction, showDisplayCosts: value });
        }
      }
    }, {
      key: "show_sales",
      label: RESX.Financial.Sales,
      render: () => <YesNoText value={props.instruction.showDisplaySales} />,
      inPageEdit: {
        render: ({ onChange }) => <YesNoRadioGroupForInPageEditing
          value={props.instruction.showDisplaySales}
          onChange={(v) => onChange(v, true)}
        />,
        type: "custom",
        initialValue: props.instruction.showDisplaySales,
        submitChange: (value: boolean) => {
          return window.CoreApi.ClientConfiguration.Update({ ...props.instruction, showDisplaySales: value });
        }
      }
    }, {
      key: "show_tickets",
      label: RESX.Ticket.Tickets,
      render: () => <YesNoText value={props.instruction.enableTickets} yesLabel={RESX.GeneralLabels.Display} noLabel={RESX.Buttons.BtnHide} />,
      inPageEdit: {
        render: ({ onChange }) => <YesNoRadioGroupForInPageEditing
          value={props.instruction.enableTickets}
          onChange={v => onChange(v, true)}
        />,
        fullWidth: true,
        type: "custom",
        initialValue: props.instruction.enableTickets,
        submitChange: (value: boolean) => {
          return window.CoreApi.ClientConfiguration.Update({ ...props.instruction, enableTickets: value });
        }
      }
    }]
  }
}